export default "__VITE_ASSET__37a3e2a5__"